document.querySelectorAll('.text-media-expandable').forEach(item => {
    item.querySelector('button').addEventListener('click', () => {
        item.classList.toggle('active')
    })
})